<script lang="ts">
    import { Button } from "sveltestrap";
    import data from "../../../../Data/Ecommerce/Ecommerce.json"
    let getId:string
    //  for grid
    const handleSize = (id:string) => {
       getId = id
    }
</script>
<div class="product-size">
    <ul>
      {#each data.sizeData as sizeItem}
        <li class={getId == sizeItem ? "active" : ""}> 
          <Button outline color="light" id={sizeItem} on:click={()=>handleSize(sizeItem)}>{sizeItem}</Button>
        </li>
      {/each}
    </ul>
</div>